<script setup lang="ts">
import { computed } from "vue"
import { useTranslation } from "i18next-vue"

const props = defineProps<{ status: number }>()
const { t } = useTranslation()

const knownStatuses = [403, 404, 422, 500, 503]

const statusKey = computed(() =>
  knownStatuses.includes(props.status) ? String(props.status) : "default",
)
</script>

<template>
  <div class="space-y-6">
    <h1>{{ t(`error_page.${statusKey}.title`, { status }) }}</h1>
    <p>{{ t(`error_page.${statusKey}.description`, { status }) }}</p>
  </div>
</template>
